import React from 'react';
import Modal from 'react-awesome-modal';
import { MandateStatus } from '../MandateStatus.ts';
import { actionSingle } from '../../../Services/IBS/IbsService';

export const AddModal = ({ addModalShow, setAddModalShow, row }) => {
    return (<Modal
        width="950"
        className="testClass"
        effect="fadeInDown"
        visible={addModalShow}
    >
        <div className="commentModal addModal" id="addModal">
            <h3> <i className="fa fa-edit"></i> Confirm uploading a data template</h3>
            <hr />
            <table className="NoAction">
                <col span="1" style={{ width: '10%' }} />
                <col span="1" style={{ width: '8%' }} />
                <col span="1" style={{ width: '16%' }} />
                <col span="1" style={{ width: '16%' }} />
                <col span="1" style={{ width: '25%' }} />
                <col span="1" style={{ width: '25%' }} />
                <thead>
                    <tr>
                        <th>Mandate ID</th>
                        <th>AgrID</th>
                        <th>Asset</th>
                        <th>Style</th>
                        <th>Manager</th>
                        <th>Fund</th>
                    </tr>
                </thead>
                <tbody>
                    {row ? <tr>
                        <td>{row.mandateId > 0 ? row.mandateId : 'NA'}</td>
                        <td>{row.status !== MandateStatus.FAILED && row.agrId !== 'Unknown' ? row.agrId : ''}</td>
                        <td>{row.status !== MandateStatus.FAILED && row.asset !== 'Unknown' ? row.asset : ''}</td>
                        <td>{row.status !== MandateStatus.FAILED && row.style !== 'Unknown' ? row.style : ''}</td>
                        <td>{row.managerName}</td>
                        <td>{row.fundName}</td>
                    </tr> : null}
                </tbody>
            </table>
            <button type="button" className="btn btn-close blue" onClick={() => {
                actionSingle(row.rowId, 'add');
                setAddModalShow(false)
            }}>Add</button>
            <button type="button" className="btn btn-close orange" onClick={() => setAddModalShow(false)}>Cancel</button>
        </div>
    </Modal>)
}